import React from 'react';
import { Chip, Typography } from '@mui/material';
import PositionMenu from './PositionMenu';
import ActionTableButton from '../../../../components/common/ActionButtonAndMenu/ActionTableButton';

export const columns = [
    {
        fieldName: 'title',
        name: 'title',
        label: 'TITLE',
        type: 'string',
        filter: true,
        title: ({ row, column }) => row[column.fieldName],
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName]}
            </Typography>
        ),
    },
    {
        fieldName: 'experience',
        name: 'experience',
        label: 'EXPERIENCE RANGE',
        type: 'string',
        filter: true,
        title: ({ row, column }) => `${row['minExperience']} - ${row['maxExperience']}`,
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {`${row['minExperience']} - ${row['maxExperience']}`}
            </Typography>
        ),
    },
    {
        fieldName: 'role',
        name: 'role',
        label: 'ROLE',
        type: 'string',
        filter: true,
        title: ({ row, column }) => row[column.fieldName],
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName]}
            </Typography>
        ),
    },
    {
        fieldName: 'location',
        name: 'location',
        label: 'LOCATION',
        type: 'string',
        filter: true,
        title: ({ row, column }) => row?.[column.fieldName]?.name,
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row?.[column.fieldName]?.name}
            </Typography>
        ),
    },
    {
        fieldName: 'status',
        name: 'status',
        label: 'STATUS',
        type: 'string',
        title: ({ row, column }) => row[column.fieldName],
        formatValue: ({ row, column }) => <Chip label={row[column.fieldName]} sx={{ backgroundColor: '#0ea5e91a' }} />,
    },
    {
        fieldName: 'readyForInternalHq',
        name: 'readyForInternalHq',
        label: 'READY FOR INTERNAL HQ',
        type: 'string',
        title: ({ row, column }) => (row[column.fieldName] ? 'Ready to move' : 'Incomplete details'),
        formatValue: ({ row, column }) => {
            const isReady = row[column.fieldName];
            const label = isReady ? 'Ready to move' : 'Incomplete details';
            const backgroundColor = isReady ? '#d6f5c7' : '#ffa7a4';
            const textColor = '#3f455a';

            return (
                <Chip
                    label={label}
                    sx={{
                        backgroundColor: backgroundColor,
                        color: textColor,
                    }}
                />
            );
        },
    },
    {
        fieldName: 'reviewPolicy',
        name: 'reviewPolicy',
        label: 'REVIEW POLICY',
        type: 'string',
        filter: true,
        title: ({ row, column }) => row[column.fieldName?.name],
        formatValue: ({ row, column }) => (
            <Typography variant="body2" noWrap>
                {row[column.fieldName]?.name}
            </Typography>
        ),
    },
    {
        id: 'action',
        label: 'Actions',
        sticky: true,
        filter: true,
        formatValue: ({ row, action }) => (
            <PositionMenu Component={ActionTableButton} row={row} handleAction={action} />
        ),
    },
];
